import AuthService from '../services/AuthService';
import FinanceService from '@/services/FinanceService';
import CommonService from '@/services/CommonService';
import MarketingService from '@/services/MarketingService';
import BusinessService from '@/services/sales/BusinessService';
import OrderService from '@/services/OrderService';
import chatStore from '@/services/chat/chatStore';
import { startChatSession, tearDownChatSession } from '@/services/chat/chatSession';

const prepareUserPermissions = (permissions) => {
	const _permissions = {};
	permissions.map(({ right, hasRight }) => {
		_permissions[right.id] = hasRight;
	});
	return _permissions;
};

const actions = {
	updateSidebar({ commit }, payload) {
		commit('SIDEBAR_UPDATED', payload);
	},
	login({ commit }, payload) {
		const chatTeardowns = chatStore.teardowns;
		return new Promise((resolve, reject) => {
			AuthService.login(payload).then(
				({ token, user, fToken }) => {
					commit('TOKEN', token);
					user.perms = prepareUserPermissions(user.permissions);
					commit('ME', user);
					commit(
						'UPDATE_SELECTED_BUSINESSES',
						user.restaurants.map(({ restaurantID }) => restaurantID)
					);
					// The fToken stays out of Vuex, whose whole state is persisted.
					startChatSession(fToken, user, chatTeardowns);
					resolve(user);
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	logout({ commit }) {
		tearDownChatSession();
		commit('LOGOUT');
	},
	me({ commit }) {
		return new Promise((resolve, reject) => {
			AuthService.me().then(
				({ data }) => {
					commit('ME', data);
					resolve();
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	getPaymentTypes({ commit }) {
		return new Promise((resolve, reject) => {
			FinanceService.getPaymentTypes().then(
				(types) => {
					commit('PAYMENT_TYPES', types);
					resolve();
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	getLocations({ commit }) {
		Promise.all([CommonService.getCountries(), CommonService.getCities({ status: 1 })]).then((res) => {
			commit('SET_COUNTRIES', res[0]);
			commit('SET_CITIES', res[1]);
		});
	},

	getPosSettings({ commit }) {
		return new Promise((resolve, reject) => {
			OrderService.getPosSettings().then(
				(settings) => {
					commit('POS_SETTINGS', settings);
					resolve();
				},
				(error) => {
					reject(error);
				}
			);
		});
	},

	getCampaignPositions({ commit }) {
		return new Promise((resolve, reject) => {
			MarketingService.getCampaignPositions().then(
				(types) => {
					commit('CAMPAIGN_POSITIONS', types);
					resolve();
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	getCampaignTypes({ commit }) {
		return new Promise((resolve, reject) => {
			MarketingService.getCampaignTypes().then(
				(types) => {
					commit('CAMPAIGN_TYPES', types);
					resolve();
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	getCampaignRedirectTypes({ commit }) {
		return new Promise((resolve, reject) => {
			MarketingService.getCampaignRedirectTypes().then(
				(types) => {
					commit('CAMPAIGN_REDIRECTION_TYPES', types);
					resolve();
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	getFilterTypes({ commit }) {
		return new Promise((resolve, reject) => {
			MarketingService.getFilterTypes().then(
				(types) => {
					commit('FILTER_TYPES', types);
					resolve();
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	getPriceRanges({ commit }) {
		return new Promise((resolve, reject) => {
			BusinessService.getPriceRanges().then(
				(types) => {
					commit('PRICE_RANGES', types);
					resolve();
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	getContactTypes({ commit }) {
		return new Promise((resolve, reject) => {
			BusinessService.getContactTypes().then(
				(types) => {
					commit('CONTACT_TYPES', types);
					resolve();
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	setBusinessClosingReasons({ commit }) {
		return new Promise((resolve, reject) => {
			BusinessService.getBusinessClosingReasons().then(
				(reasons) => {
					commit('SET_BUSINESS_CLOSING_REASONS', reasons);
					resolve(reasons);
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	setBusinessRejectReasons({ commit }) {
		return new Promise((resolve, reject) => {
			BusinessService.getBusinessRejectReasons().then(
				(res) => {
					console.log(res);
					let reasons = [...res];
					reasons.push({
						id: 0,
						value: 0,
						label: 'Tjeter',
						description: 'Tjeter',
						type: 'OTHER',
						status: 1,
						system: 0,
					});
					console.log(reasons);
					commit('SET_BUSINESS_REJECT_REASONS', reasons);
					resolve(reasons);
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	setSelectedBusinessId({ commit }, id) {
		commit('SET_SELECTED_BUSINESS_ID', id);
	},
	setLoadingOrderId({ commit }, id) {
		commit('SET_LOADING_ORDER_ID', id);
	},
};

export default actions;
